import { addPermissionsToRoute } from '@qsrsoft/myq-core';
const routes = {
  name: 'Service',
  icon: 'mdi-hand-heart-outline',
  path: '/reports/service',
  children: [
    {
      path: '/reports/service/serviceTimesStatistics',
      name: 'Service Times Statistics',
      meta: { id: 'mc-serviceTimesStatistics', permission: 'service' },
      component: () => import('./SpeedOfService.vue'),
      ...addPermissionsToRoute(['service']),
    },
  ],
};

export default routes;
